<template>
	
<transition name="modal">

	<com-filter-directory :data="modal.filterDirectory" v-on:close="onClose('filterDirectory')" v-if="modal.filterDirectory" />
	<com-filter-rule :data="modal.filterRule" v-on:close="onClose('filterRule')" v-if="modal.filterRule" />

	<com-session-patreon-connect :data="modal.sessionPatreonConnect" v-on:close="onClose('sessionPatreonConnect')" v-if="modal.sessionPatreonConnect" />

	<com-session-patreon-boosts-choose :data="modal.sessionPatreonBoostsChoose" v-on:close="onClose('sessionPatreonBoostsChoose')" v-if="modal.sessionPatreonBoostsChoose" />
	<com-session-patreon-boosts-remove :data="modal.sessionPatreonBoostsRemove" v-on:close="onClose('sessionPatreonBoostsRemove')" v-if="modal.sessionPatreonBoostsRemove" />

	<com-session-patreon-syncs-choose :data="modal.sessionPatreonSyncsChoose" v-on:close="onClose('sessionPatreonSyncsChoose')" v-if="modal.sessionPatreonSyncsChoose" />
	<com-session-patreon-syncs-remove :data="modal.sessionPatreonSyncsRemove" v-on:close="onClose('sessionPatreonSyncsRemove')" v-if="modal.sessionPatreonSyncsRemove" />

	<com-session-patreon-subdomains-user :data="modal.sessionPatreonSubdomainsUser" v-on:close="onClose('sessionPatreonSubdomainsUser')" v-if="modal.sessionPatreonSubdomainsUser" />
	<com-session-patreon-subdomains-group :data="modal.sessionPatreonSubdomainsGroup" v-on:close="onClose('sessionPatreonSubdomainsGroup')" v-if="modal.sessionPatreonSubdomainsGroup" />

	<com-session-patreon-externaldomains-user :data="modal.sessionPatreonExternaldomainsUser" v-on:close="onClose('sessionPatreonExternaldomainsUser')" v-if="modal.sessionPatreonExternaldomainsUser" />
	<com-session-patreon-externaldomains-group :data="modal.sessionPatreonExternaldomainsGroup" v-on:close="onClose('sessionPatreonExternaldomainsGroup')" v-if="modal.sessionPatreonExternaldomainsGroup" />

	<com-game-rename :data="modal.gameRename" v-on:close="onClose('gameRename')" v-if="modal.gameRename" />

	<com-activity-delete :data="modal.activityDelete" v-on:close="onClose('activityDelete')" v-if="modal.activityDelete" />

	<com-app-about :data="modal.appAbout" v-on:close="onClose('appAbout')" v-if="modal.appAbout" />
	<com-app-log :data="modal.appLog" v-on:close="onClose('appLog')" v-if="modal.appLog" />
	<com-app-updates :data="modal.appUpdates" v-on:close="onClose('appUpdates')" v-if="modal.appUpdates" />
	<com-app-update :data="modal.appUpdate" v-on:close="onClose('appUpdate')" v-if="modal.appUpdate" />
	<com-app-terms :data="modal.appTerms" v-on:close="onClose('appTerms')" v-if="modal.appTerms" />
	<com-app-syncs :data="modal.appSyncs" v-on:close="onClose('appSyncs')" v-if="modal.appSyncs" />
	<com-app-privacy :data="modal.appPrivacy" v-on:close="onClose('appPrivacy')" v-if="modal.appPrivacy" />

	<com-views-manage :data="modal.viewsManage" v-on:close="onClose('viewsManage')" v-if="modal.viewsManage && loggedin" />
	<com-views-manage-create :data="modal.viewsManageCreate" v-on:close="onClose('viewsManageCreate')" v-if="modal.viewsManageCreate && loggedin" />
	<com-views-manage-default :data="modal.viewsManageDefault" v-on:close="onClose('viewsManageDefault')" v-if="modal.viewsManageDefault && loggedin" />
	<com-views-view :data="modal.viewsView" v-on:close="onClose('viewsView')" v-if="modal.viewsView && loggedin" />
	<com-views-view-settings :data="modal.viewsViewSettings" v-on:close="onClose('viewsViewSettings')" v-if="modal.viewsViewSettings && loggedin" />
	<com-views-view-delete :data="modal.viewsViewDelete" v-on:close="onClose('viewsViewDelete')" v-if="modal.viewsViewDelete && loggedin" />
	<com-views-view-add :data="modal.viewsViewAdd" v-on:close="onClose('viewsViewAdd')" v-if="modal.viewsViewAdd && loggedin" />
	<com-views-view-field :data="modal.viewsViewField" v-on:close="onClose('viewsViewField')" v-if="modal.viewsViewField && loggedin" />

	<com-tag-family-create :data="modal.tagFamilyCreate" v-on:close="onClose('tagFamilyCreate')" v-if="modal.tagFamilyCreate && loggedin" />
	<com-tag-family-manage :data="modal.tagFamilyManage" v-on:close="onClose('tagFamilyManage')" v-if="modal.tagFamilyManage && loggedin" />
	<com-tag-family-edit :data="modal.tagFamilyEdit" v-on:close="onClose('tagFamilyEdit')" v-if="modal.tagFamilyEdit && loggedin" />
	<com-tag-family-delete :data="modal.tagFamilyDelete" v-on:close="onClose('tagFamilyDelete')" v-if="modal.tagFamilyDelete && loggedin" />
	
	<com-tag-move :data="modal.tagMove" v-on:close="onClose('tagMove')" v-if="modal.tagMove && loggedin" />
	<com-tag-manage :data="modal.tagManage" v-on:close="onClose('tagManage')" v-if="modal.tagManage && loggedin" />
	<com-tag-create :data="modal.tagCreate" v-on:close="onClose('tagCreate')" v-if="modal.tagCreate && loggedin" />
	<com-tag-edit :data="modal.tagEdit" v-on:close="onClose('tagEdit')" v-if="modal.tagEdit && loggedin" />
	<com-tag-delete :data="modal.tagDelete" v-on:close="onClose('tagDelete')" v-if="modal.tagDelete && loggedin" />

	<com-group-create v-on:close="onClose('groupCreate')" v-if="modal.groupCreate && loggedin" />
	<com-group-add v-on:close="onClose('groupAdd')" v-if="modal.groupAdd && loggedin" />
	<com-group-leave v-on:close="onClose('groupLeave')" v-if="modal.groupLeave && loggedin" />
	<com-group-remove :data="modal.groupRemove" v-on:close="onClose('groupRemove')" v-if="modal.groupRemove && loggedin" />
	<com-group-join v-on:close="onClose('groupJoin')" v-if="modal.groupJoin" />
	<com-group-edit v-on:close="onClose('groupEdit')" v-if="modal.groupEdit && loggedin" />
	<com-group-delete v-on:close="onClose('groupDelete')" v-if="modal.groupDelete && loggedin" />
			
	<com-user-notifications v-on:close="onClose('userNotifications')" v-if="modal.userNotifications && loggedin" />
	<com-user-notification :data="modal.userNotification" v-on:close="onClose('userNotification')" v-if="modal.userNotification && loggedin" />
	<com-user-sync v-on:close="onClose('userSync')" v-if="modal.userSync && loggedin" />
	<com-user-deep v-on:close="onClose('userDeep')" v-if="modal.userDeep && loggedin" />
	<com-user-login v-on:close="onClose('userLogin')" v-if="modal.userLogin && !loggedin" />
	<com-user-register v-on:close="onClose('userRegister')" v-if="modal.userRegister && !loggedin" />
	<com-user-forgot v-on:close="onClose('userForgot')" v-if="modal.userForgot && !loggedin" />
	<com-user-password v-on:close="onClose('userPassword')" v-if="modal.userPassword && loggedin" />
	<com-user-tipjar v-on:close="onClose('userTipjar')" v-if="modal.userTipjar && loggedin" />
	<com-user-settings v-on:close="onClose('userSettings')" v-if="modal.userSettings && loggedin" />
	<com-user-groups v-on:close="onClose('userGroups')" v-if="modal.userGroups && loggedin" />
			
	<com-list-create v-on:close="onClose('listCreate')" v-if="modal.listCreate && loggedin" />
	<com-list-delete v-on:close="onClose('listDelete')" v-if="modal.listDelete && loggedin" />
	<com-list-edit v-on:close="onClose('listEdit')" v-if="modal.listEdit && loggedin" />
	<com-list-edition-move :data="modal.listEditionMove" v-on:close="onClose('listEditionMove')" v-if="modal.listEditionMove && loggedin" />
	<com-list-edition-create :data="modal.listEditionCreate" v-on:close="onClose('listEditionCreate')" v-if="modal.listEditionCreate && loggedin" />
	<com-list-edition-delete v-on:close="onClose('listEditionDelete')" v-if="modal.listEditionDelete && loggedin" />

	<com-preset-create :data="modal.presetCreate" v-on:close="onClose('presetCreate')" v-if="modal.presetCreate && loggedin" />
	<com-preset-edit :data="modal.presetEdit" v-on:close="onClose('presetEdit')" v-if="modal.presetEdit && loggedin" />
	<com-preset-delete :data="modal.presetDelete" v-on:close="onClose('presetDelete')" v-if="modal.presetDelete && loggedin" />

	<com-hindex-create :data="modal.hindexCreate" v-on:close="onClose('hindexCreate')" v-if="modal.hindexCreate && loggedin" />
	<com-hindex-browse :data="modal.hindexBrowse" v-on:close="onClose('hindexBrowse')" v-if="modal.hindexBrowse && loggedin" />
	<com-hindex-view :data="modal.hindexView" v-on:close="onClose('hindexView')" v-if="modal.hindexView" />
	<com-hindex-filter :data="modal.hindexFilter" v-on:close="onClose('hindexFilter')" v-if="modal.hindexFilter && loggedin" />

	<com-about-sync v-on:close="onClose('aboutSync')" v-if="modal.aboutSync" />

	<com-help-worth :data="modal.helpWorth" v-on:close="onClose('helpWorth')" v-if="modal.helpWorth" />
	<com-help-shelf :data="modal.helpShelf" v-on:close="onClose('helpShelf')" v-if="modal.helpShelf" />

</transition>

</template>

<script>

import filterDirectory from './filter/Directory'
import filterRule from './filter/Rule'

import sessionPatreonConnect from './session/patreon/Connect'

import sessionPatreonBoostsChoose from './session/patreon/boosts/Choose'
import sessionPatreonBoostsRemove from './session/patreon/boosts/Remove'

import sessionPatreonSyncsChoose from './session/patreon/syncs/Choose'
import sessionPatreonSyncsRemove from './session/patreon/syncs/Remove'

import sessionPatreonSubdomainsUser from './session/patreon/subdomains/User'
import sessionPatreonSubdomainsGroup from './session/patreon/subdomains/Group'

import sessionPatreonExternaldomainsUser from './session/patreon/externaldomains/User'
import sessionPatreonExternaldomainsGroup from './session/patreon/externaldomains/Group'

import activityDelete from './activity/Delete'

import gameRename from './game/Rename'

import appUpdates from './app/Updates'
import appUpdate from './app/Update'
import appAbout from './app/About'
import appLog from './app/Log'
import appTerms from './app/Terms'
import appPrivacy from './app/Privacy'
import appSyncs from './app/Syncs'

import hindexCreate from './hindex/Create'
import hindexBrowse from './hindex/Browse'
import hindexFilter from './hindex/Filter'
import hindexView from './hindex/View'

import viewsManageCreate from './views/Create'
import viewsManageDefault from './views/Default'
import viewsManage from './views/Manage'
import viewsView from './views/View'
import viewsViewAdd from './views/Directory'
import viewsViewField from './views/Field'
import viewsViewSettings from './views/Settings'
import viewsViewDelete from './views/Delete'

import tagFamilyCreate from './tag/family/Create'
import tagFamilyManage from './tag/family/Manage'
import tagFamilyEdit from './tag/family/Edit'
import tagFamilyDelete from './tag/family/Delete'

import tagMove from './tag/Move'
import tagManage from './tag/Manage'
import tagCreate from './tag/Create'
import tagEdit from './tag/Edit'
import tagDelete from './tag/Delete'

import groupCreate from './group/Create'
import groupAdd from './group/Add'
import groupLeave from './group/Leave'
import groupJoin from './group/Join'
import groupEdit from './group/Edit'
import groupDelete from './group/Delete'
import groupRemove from './group/Remove'

import userNotifications from './user/Notifications'
import userNotification from './user/Notification'
import userSync from './user/Sync'
import userDeep from './user/Deep'
import userLogin from './user/Login'
import userRegister from './user/Register'
import userForgot from './user/Forgot'
import userPassword from './user/Password'
import userTipjar from './user/Tipjar'
import userSettings from './user/Settings'
import userGroups from './user/Groups'

import listCreate from './list/Create'
import listDelete from './list/Delete'
import listEdit from './list/Edit'
import listEditionCreate from './list/edition/Create'
import listEditionDelete from './list/edition/Delete'
import listEditionMove from './list/edition/Move'

import presetCreate from './preset/Create'
import presetEdit from './preset/Edit'
import presetDelete from './preset/Delete'

import aboutSync from './about/Sync'

import helpWorth from './help/Worth'
import helpShelf from './help/Shelf'

export default {

	components: {
		'com-filter-directory': filterDirectory,
		'com-filter-rule': filterRule,
		'com-session-patreon-connect': sessionPatreonConnect,
		'com-session-patreon-boosts-choose': sessionPatreonBoostsChoose,
		'com-session-patreon-boosts-remove': sessionPatreonBoostsRemove,
		'com-session-patreon-syncs-choose': sessionPatreonSyncsChoose,
		'com-session-patreon-syncs-remove': sessionPatreonSyncsRemove,
		'com-session-patreon-subdomains-user': sessionPatreonSubdomainsUser,
		'com-session-patreon-subdomains-group': sessionPatreonSubdomainsGroup,
		'com-session-patreon-externaldomains-user': sessionPatreonExternaldomainsUser,
		'com-session-patreon-externaldomains-group': sessionPatreonExternaldomainsGroup,
		'com-hindex-create': hindexCreate,
		'com-hindex-browse': hindexBrowse,
		'com-hindex-view': hindexView,
		'com-hindex-filter': hindexFilter,
		'com-activity-delete': activityDelete,
		'com-game-rename': gameRename,
		'com-app-updates': appUpdates,
		'com-app-update': appUpdate,
		'com-app-about': appAbout,
		'com-app-log': appLog,
		'com-app-terms': appTerms,
		'com-app-privacy': appPrivacy,
		'com-app-syncs': appSyncs,
		'com-views-manage-create': viewsManageCreate,
		'com-views-manage-default': viewsManageDefault,
		'com-views-manage': viewsManage,
		'com-views-view': viewsView,
		'com-views-view-add': viewsViewAdd,
		'com-views-view-field': viewsViewField,
		'com-views-view-settings': viewsViewSettings,
		'com-views-view-delete': viewsViewDelete,
		'com-tag-move': tagMove,
		'com-tag-manage': tagManage,
		'com-tag-create': tagCreate,
		'com-tag-family-create': tagFamilyCreate,
		'com-tag-family-manage': tagFamilyManage,
		'com-tag-family-edit': tagFamilyEdit,
		'com-tag-family-delete': tagFamilyDelete,
		'com-tag-edit': tagEdit,
		'com-tag-delete': tagDelete,
		'com-group-create': groupCreate,
		'com-group-add': groupAdd,
		'com-group-leave': groupLeave,
		'com-group-join': groupJoin,
		'com-group-edit': groupEdit,
		'com-group-delete': groupDelete,
		'com-group-remove': groupRemove,
		'com-user-notifications': userNotifications,
		'com-user-notification': userNotification,
		'com-user-sync': userSync,
		'com-user-deep': userDeep,
		'com-user-login': userLogin,
		'com-user-register': userRegister,
		'com-user-forgot': userForgot,
		'com-user-password': userPassword,
		'com-user-settings': userSettings,
		'com-user-tipjar': userTipjar,
		'com-user-groups': userGroups,
		'com-list-create': listCreate,
		'com-list-delete': listDelete,
		'com-list-edit': listEdit,
		'com-list-edition-move': listEditionMove,
		'com-list-edition-create': listEditionCreate,
		'com-list-edition-delete': listEditionDelete,
		'com-preset-create': presetCreate,
		'com-preset-edit': presetEdit,
		'com-preset-delete': presetDelete,
		'com-about-sync': aboutSync,
		'com-help-worth': helpWorth,
		'com-help-shelf': helpShelf
	},

	data: function() {

		return {

			modal: {
				filterDirectory: false,
				filterRule: false,
				sessionPatreonConnect: false,
				sessionPatreonBoostsChoose: false,
				sessionPatreonBoostsRemove: false,
				sessionPatreonSyncsChoose: false,
				sessionPatreonSyncsRemove: false,
				sessionPatreonSubdomainsUser: false,
				sessionPatreonSubdomainsGroup: false,
				sessionPatreonExternaldomainsUser: false,
				sessionPatreonExternaldomainsGroup: false,
				hindexCreate: false,
				hindexBrowse: false,
				hindexView: false,
				hindexFilter: false,
				activityDelete: false,
				gameRename: false,
				appUpdates: false,
				appUpdate: false,
				appAbout: false,
				appLog: false,
				appSyncs: false,
				appTerms: false,
				appPrivacy: false,
				viewsManageCreate: false,
				viewsManageDefault: false,
				viewsManage: false,
				viewsView: false,
				viewsViewAdd: false,
				viewsViewField: false,
				viewsViewSettings: false,
				viewsViewDelete: false,
				tagManage: false,
				tagMove: false,
				tagCreate: false,
				tagFamilyCreate: false,
				tagFamilyManage: false,
				tagFamilyEdit: false,
				tagFamilyDelete: false,
				tagEdit: false,
				tagDelete: false,
				groupCreate: false,
				groupAdd: false,
				groupLeave: false,
				groupJoin: false,
				groupEdit: false,
				groupDelete: false,
				groupRemove: false,
				userSync: false,
				userNotifications: false,
				userNotification: false,
				userDeep: false,
				userForgot: false,
				userLogin: false,
				userRegister: false,
				userPassword: false,
				userTipjar: false,
				userSettings: false,
				userGroups: false,
				listCreate: false,
				listDelete: false,
				listEdit: false,
				listEditionCreate: false,
				listEditionMove: false,
				listEditionDelete: false,
				presetCreate: false,
				presetEdit: false,
				presetDelete: false,
				aboutSync: false,
				helpWorth: false,
				helpShelf: false
			}

		}

	},

	created: function() {

		this.$pubsub.$on('open.modal', function(e) {

			if (e.root) {

				this.$_.each(this.modal, function(modal, key) {

					if (this.modal[key]) this.onClose(key)

				}.bind(this))

			} else {
			
				this.$_.each(this.modal, function(value, key) {

					if (this.modal[key]) {

						this.onClose(key)

					}

				}.bind(this))

			}

			var id = (typeof e === 'string') ? e : e.id

			this.modal[id] = e

		}.bind(this))

		this.$pubsub.$on('close.modals', function() {

			this.$_.each(this.modal, function(value, key) {

				if (this.modal[key]) {

					this.onClose(key)

				}

			}.bind(this))

		}.bind(this))

	},

	methods: {

		onClose: function(id) {

			this.modal[id] = false

		}

	}

}

</script>

<style>

.is-desktop .modal-enter-active,
.is-smaller .modal-enter-active {
	animation: menu-slide 100ms linear;
}

.is-desktop .modal-leave-active,
.is-smaller .modal-leave-active {
	animation: menu-slide 100ms reverse;
}

.is-desktop .modal-enter-active.is-large,
.is-smaller .modal-enter-active.is-large {
	animation: menu-slide-right 100ms linear;
}

.is-desktop .modal-leave-active.is-large,
.is-smaller .modal-leave-active.is-large {
	animation: menu-slide-right 100ms reverse;
}

@keyframes menu-slide {
	from {
		transform: translateX(-384px);
	}
	to {
		transform: translateX(0px);
	}
}

@keyframes menu-slide-right {
	from {
		transform: translateX(384px);
	}
	to {
		transform: translateX(0px);
	}
}
</style>